var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e50a0",
    d: "M5 17h62v38H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 28.856V32h10.181L67 21.691V17h-7.654z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M67 17h-3.827L40 31.203V32h3.482L67 17.586z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.347 55H67v-4.692L50.182 40H40v3.143z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M67 55v-2.347L46.355 40h-4.787l24.474 15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 43.144V40H21.819L5 50.309V55h7.654z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M5 55h3.827L32 40.797V40h-3.482L5 54.414z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.653 17H5v4.692L21.818 32H32v-3.143z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M5 17v2.347L25.646 32h4.786L5.958 17z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 31h62v10H5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31 17h10v38H31z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M5 33h62v6H5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22f27",
    d: "M33 17h6v38h-6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 17h62v38H5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.abd4909fd8703cc5f45226db3c0db600.svg";
export { ForwardRef as ReactComponent };